var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.290039,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#009B4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2406 12.2915C16.5995 12.2703 16.9239 12.4848 17.1698 12.8655L19.5511 17.3816C19.8019 17.9168 19.6594 18.4898 19.2854 18.8721L18.1946 19.9629C18.1273 20.0551 18.083 20.159 18.0819 20.2733C18.5002 21.8924 19.7691 23.386 20.8886 24.413C22.008 25.4401 23.2112 26.8307 24.7731 27.1601C24.9661 27.214 25.2026 27.2333 25.3408 27.1049L26.608 25.8143C27.0454 25.4827 27.6782 25.322 28.1453 25.5931H28.1665L32.4635 28.1297C33.0943 28.5251 33.1596 29.2893 32.708 29.7542L29.7484 32.6905C29.3114 33.1387 28.7307 33.2894 28.1666 33.29C25.6715 33.2153 23.314 31.9907 21.3776 30.7322C18.1991 28.4199 15.2836 25.5519 13.4532 22.087C12.7512 20.634 11.9265 18.7802 12.0052 17.1584C12.0123 16.5483 12.1773 15.9506 12.607 15.5574L15.5666 12.5977C15.7972 12.4015 16.0253 12.3042 16.2406 12.2915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.4888b96db3115c7b5aa3da39712819a6.svg";
export { ForwardRef as ReactComponent };